import { connect } from 'react-redux';

import InstallerTestExpectedModalComponent
  from './../Components/InstallerTestExpectedModalComponent.jsx';
import { modal as modalActions } from './../actions';
import { getModalVisibility } from './../reducers';
import { owners } from './../helpers/modals';

export const mapStateToProps = (state, ownProps) => {
  return {
    visible: getModalVisibility(state, owners.testsExpected),
    buildPage: ownProps.buildPage === true
  };
};

export default connect(
  mapStateToProps,
  { onHide: () => modalActions.showTestsExpectedModal(false) }
)(InstallerTestExpectedModalComponent);


// WEBPACK FOOTER //
// src/Containers/InstallerTestExpectedModalContainer.jsx